import script from "./cria-cadencia.vue?vue&type=script&setup=true&lang=js"
export * from "./cria-cadencia.vue?vue&type=script&setup=true&lang=js"

import "./cria-cadencia.vue?vue&type=style&index=0&id=bd0b1098&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd0b1098"]])

export default __exports__